<template>
  <div>
    <div class="page-title ">
      {{ $t('menu.user_list') }}
    </div>
    <div class="system-user-list page-container">

      <div class="filter-container">
        <div class="filter-container-tag">
          {{ $t('components.activity') }}
        </div>
        <el-input v-model="search.username" placeholder="Username" class="search-frame" clearable />

        <el-button type="primary" class="search-btn" icon="el-icon-search" @click="handleFilter">{{ $t('components.search') }}</el-button>

        <el-button type="primary" class="filter-btn-add mb10 " @click="showAddUserModal"><i style="font-weight: 600" class="el-icon-plus" /> {{ $t('system.add_user') }}</el-button>
      </div>
      <div class="tableContainer">
        <el-table
          v-loading="listLoading"
          :data="tableData"
          stripe
          fit
          highlight-current-row
          style="width: 100%"
        >
          <el-table-column :label="$t('system.username')" align="center">
            <template slot-scope="scope">
              {{ scope.row.username }}
            </template>
          </el-table-column>

          <el-table-column :label="$t('system.login_email')" align="center">
            <template slot-scope="scope">
              {{ scope.row.email }}
            </template>
          </el-table-column>

          <el-table-column :label="$t('system.authorized_status')" align="center">
            <template slot-scope="scope">
              <el-switch
                v-model="scope.row.on_off"
                :active-value="1"
                :inactive-value="2"
                active-color="#3855F1"
                inactive-color="#98A1B4"
                @change="changeAuthorizedStatus(scope.row)"
              />
            </template>
          </el-table-column>

          <el-table-column v-if="$store.getters.isPii || $store.getters.isEz || $store.getters.isAruxpay" :label="$t('system.notification_config')" align="center" min-width="125">
            <template slot-scope="scope">
              <el-button type="success" size="mini" @click="showNotificationConfigModal(scope.row)">{{ $t('system.notification_config') }}</el-button>
            </template>
          </el-table-column>

          <el-table-column :label="$t('system.role')" align="center">
            <template slot-scope="scope">
              <el-button type="info" style="margin: 5px" size="small" @click="showModifyAuthModal(scope.row)">{{ $t('system.assign_role') }}</el-button>
            </template>
          </el-table-column>

          <el-table-column :label="$t('components.create_time')" align="center">
            <template slot-scope="scope">
              {{ scope.row.create_time }}
            </template>
          </el-table-column>

          <!--<el-table-column align="center">
            <template slot="header">
              {{ $t('system.mfa_status') }}
              <el-tooltip placement="top">
                <div slot="content" style="width: 300px">
                  <span>{{ $t('tips.mfa_status_tips') }}</span>
                </div>
                <svg-icon style="position: relative;top: -1px" icon-class="help-question" class="icon-question-tip" />
              </el-tooltip>
            </template>
            <template slot-scope="scope">
              <el-switch
                v-model="scope.row.mfa_enable"
                :active-value="1"
                :inactive-value="2"
                active-color="#3855F1"
                inactive-color="#98A1B4"
                @change="changeMFAStatus(scope.row)"
              />
            </template>
          </el-table-column>  -->

          <!--          <el-table-column :label="$t('components.operation')" align="center" min-width="120">-->
          <!--            <template slot-scope="scope">-->
          <!--              <el-popover-->
          <!--                placement="top"-->
          <!--                trigger="click">-->
          <!--                <div class="text-align-center">-->
          <!--                  <el-button type="primary" plain style="width: 100%; margin: 5px 0; border: none; font-size: 14px;" size="small" @click="reSetMfaCode(scope.row)">{{ $t('system.reset_mfa') }}</el-button>-->
          <!--                  <el-button v-show="!(scope.row.username === $store.getters.mainUserName)" type="primary" plain style="width: 100%; margin: 5px 0; border: none;font-size: 14px;" size="small" @click="showModifyPwdModal(scope.row)">{{ $t('system.modify_pwd') }}</el-button>-->
          <!--                </div>-->
          <!--                <span slot="reference" style="cursor: pointer; padding: 5px">  •••-->
          <!--                </span>-->
          <!--              </el-popover>-->
          <!--              &lt;!&ndash;            <el-button type="success" icon="el-icon-unlock" style="margin: 5px;" size="mini" @click="unlockMerchantLimit(scope.row)"></el-button>&ndash;&gt;-->
          <!--            </template>-->
          <!--          </el-table-column>-->
        </el-table>

        <div class="pagination-container">
          <paginator v-if="!listLoading" :list-query="listQuery" @paginator-change="confirm" />
        </div>
      </div>

      <add-user-modal />
      <modify-pwd-modal />
      <!--    <modify-auth-modal-->
      <!--      ref="modifyAuthRef"-->
      <!--      :auth-list="auth_list"-->
      <!--      :role-list="role_list"-->
      <!--    />-->
      <assign-role-modal
        ref="assignRoleRef"
        :menu-list="menu_list"
        @updateRoleList="handleFilter"
      />
      <NotificationConfigModalGlobal />
    </div>
  </div>
</template>

<script>
import { fetchMerchantUsers, fetchMchMenuList, updateUserAuthorizedStatus, unlockMchUser, resetMFA, changeMFAStatus } from '@/api/system/system'
import {
  cryptoJSAesDecrypt,
  cryptoJSAesEncrypt,
  strAesDecryptAndAsterisk,
  strAesDecryptAndEmailAsterisk
} from '@/utils/encrypt'
export default {
  name: 'System_User_List',
  components: {
    Paginator: () => import('@/views/components/Paginator'),
    AddUserModal: () => import ('./components/Modal/AddUserModal'),
    ModifyPwdModal: () => import ('./components/Modal/ModifyPwdModal'),
    AssignRoleModal: () => import ('./components/Modal/AssignRoleModal'),
    NotificationConfigModalGlobal: () => import ('./components/Modal/NotificationConfigModalGlobal.vue')
  },
  data() {
    return {
      search: {
        username: ''
      },
      tableData: [],
      auth_list: [],
      menu_list: [],
      listLoading: false,
      listQuery: {
        page: 1,
        limit: 15,
        total: 0
      },
      userId: 0
    }
  },
  mounted() {
    this.$bus.off('RE_GER_MERCHANT_USER')
    this.$bus.on('RE_GER_MERCHANT_USER', () => {
      this.getMerchantUsers()
    })
    this.getMerchantUsers()
    this.getMchMenuList()
  },
  methods: {
    confirm() {
      const params = {
        page: this.listQuery.page
      }
      this.handleFilter(params)
    },
    handleFilter(params = {}) {
      if (this.search.username) {
        params.username = this.search.username
      }
      this.getMerchantUsers(params)
    },
    showModifyPwdModal(row) {
      this.$bus.emit('SHOW_MODIFY_PWD_MODAL', [true, row.email])
    },
    showNotificationConfigModal(row) {
      this.$bus.emit('SHOW_NOTIFICATION_CONFIG_MODAL', [true, row])
    },
    showModifyAuthModal(row) {
      this.$refs.assignRoleRef.changeModalStatus(true, row)
    },
    showAddUserModal() {
      this.$bus.emit('SHOW_ADD_USER_MODAL', [true])
    },
    getMerchantUsers(params = {}) {
      this.listLoading = true
      fetchMerchantUsers(params).then(res => {
        // this.auth_list = res.data.auth_list
        // this.tableData = this.formatData(res.data.list)
        // todo 确认马来是否加解密
        this.tableData = res.data.list
        this.listQuery.total = res.data.total
        this.listQuery.page = params.page ? params.page : 1
      }).finally(() => {
        this.listLoading = false
      })
    },
    getMchMenuList(params = {}) {
      fetchMchMenuList(params).then(res => {
        if (res.code === 10000) {
          this.menu_list = res.data
        }
      })
    },
    formatData(data = []) {
      const mechantId = this.$store.getters.userInfo.merchant.id
      return data.filter(item => {
        let username = cryptoJSAesDecrypt(item.username)
        let email = cryptoJSAesDecrypt(item.email)

        if (process.env.NODE_ENV === 'production' && mechantId === 31) {
          username = strAesDecryptAndAsterisk(item.username)
          email = strAesDecryptAndEmailAsterisk(item.email)
        }

        if (process.env.NODE_ENV === 'development' && mechantId === 7) {
          username = strAesDecryptAndAsterisk(item.username)
          email = strAesDecryptAndEmailAsterisk(item.email)
        }

        item.username = username
        item.email = email

        return item
      })
    },
    changeAuthorizedStatus(row) {
      if (row.on_off !== 1) {
        this.$confirm(this.$t('tips.do_want_close_access_permission'), this.$t('components.tips'), {
          confirmButtonText: this.$t('components.confirm'),
          cancelButtonText: this.$t('components.cancel'),
          type: 'warning'
        }).then(() => {
          this.updateUserAuthStatus(row)
        }).catch(() => {
          row.on_off = 1
        })
      } else {
        this.updateUserAuthStatus(row)
      }
    },
    changeMFAStatus(row) {
      this.$confirm(this.$t('tips.do_want_change_mfa_status'), this.$t('components.tips'), {
        confirmButtonText: this.$t('components.confirm'),
        cancelButtonText: this.$t('components.cancel'),
        type: 'warning'
      }).then(() => {
        const params = {
          email: cryptoJSAesEncrypt(row.email),
          mfa_enable: row.mfa_enable
        }
        changeMFAStatus(params).then(res => {
          this.$message.success('Success')
        }).finally(() => {
          this.confirm()
        })
      }).catch(() => {
        this.confirm()
      })
    },
    updateUserAuthStatus(row) {
      const params = {
        email: cryptoJSAesEncrypt(row.email),
        on_off: row.on_off
      }
      updateUserAuthorizedStatus(params).then(res => {
        this.$message.success('Success')
      })
    },
    unlockMerchantLimit(row) {
      const params = {
        mch_user_id: row.id
      }
      unlockMchUser(params).then(res => {
        if (res.code === 10000) {
          this.$message.success('Success')
        }
      })
    },

    reSetMfaCode(row) {
      this.$confirm(this.$t('tips.do_reset_mfa_verfication_code'), this.$t('components.tips'), {
        confirmButtonText: this.$t('components.confirm'),
        cancelButtonText: this.$t('components.cancel'),
        type: 'warning'
      }).then(() => {
        const params = {
          email: cryptoJSAesEncrypt(row.email)
        }
        resetMFA(params).then(res => {
          if (res.code === 10000) {
            this.$message.success('Success')
          }
        })
      })
    }
  }
}
</script>

<style scoped>
  .system-user-list{
  }
  .filter-container{
    position: relative;
    margin-bottom: 38px;
    text-align: right;
  }
  .search-frame {
    width: 160px;
    margin-left: 5px;
  }
  .search-btn {
    margin-left: 10px;
  }
  .add-btn{
    color: #fff;
  }
</style>
